export const ADDON_ANIMAL = 'animal'
export const ADDON_ASSISTANCE = 'assistance'
export const ADDON_ELEMENT = 'element'
export const ADDON_GLASS = 'glass'
export const ADDON_INJURY = 'injury'
export const ADDON_LIABILITY = 'liability'
export const ADDON_LUGGAGE = 'luggage'
export const ADDON_THEFT = 'theft'
export const ALL_ADDONS = [
  ADDON_ANIMAL,
  ADDON_ASSISTANCE,
  ADDON_ELEMENT,
  ADDON_GLASS,
  ADDON_INJURY,
  ADDON_LIABILITY,
  ADDON_LUGGAGE,
  ADDON_THEFT,
] as const

export type Addons = typeof ALL_ADDONS[number]

export const ANIMAL_COVERAGE_2500 = '2500' as const
export const ANIMAL_COVERAGE_5000 = '5000' as const
export const ANIMAL_COVERAGE_7500 = '7500' as const
export const ANIMAL_COVERAGE = {
  [ANIMAL_COVERAGE_2500]: 'COVERAGE_2500',
  [ANIMAL_COVERAGE_5000]: 'COVERAGE_5000',
  [ANIMAL_COVERAGE_7500]: 'COVERAGE_7500',
}
export const ANIMAL_COVERAGE_DEFAULT = ANIMAL_COVERAGE_2500

export const ASSISTANCE_COVERAGE_CLASSIC = 'classic' as const
export const ASSISTANCE_COVERAGE_EXTRA = 'extra' as const
export const ASSISTANCE_COVERAGE = {
  [ASSISTANCE_COVERAGE_CLASSIC]: 'CLASSIC',
  [ASSISTANCE_COVERAGE_EXTRA]: 'EXTRA',
}
export const ASSISTANCE_COVERAGE_DEFAULT = ASSISTANCE_COVERAGE_CLASSIC

export const LUGGAGE_COVERAGE_300 = '300' as const
export const LUGGAGE_COVERAGE_600 = '600' as const
export const LUGGAGE_COVERAGE_1000 = '1000' as const
export const LUGGAGE_COVERAGE = {
  [LUGGAGE_COVERAGE_300]: 'COVERAGE_300',
  [LUGGAGE_COVERAGE_600]: 'COVERAGE_600',
  [LUGGAGE_COVERAGE_1000]: 'COVERAGE_1000',
}
export const LUGGAGE_COVERAGE_DEFAULT = LUGGAGE_COVERAGE_300

export const GLASS_COVERAGE_200 = '200' as const
export const GLASS_COVERAGE_500 = '500' as const
export const GLASS_COVERAGE_700 = '700' as const
export const GLASS_COVERAGE_1000 = '1000' as const
export const GLASS_COVERAGE_1500 = '1500' as const
export const GLASS_COVERAGE = {
  [GLASS_COVERAGE_200]: 'COVERAGE_300',
  [GLASS_COVERAGE_500]: 'COVERAGE_500',
  [GLASS_COVERAGE_700]: 'COVERAGE_700',
  [GLASS_COVERAGE_1000]: 'COVERAGE_1000',
  [GLASS_COVERAGE_1500]: 'COVERAGE_1500',
}
export const GLASS_COVERAGE_DEFAULT = GLASS_COVERAGE_200

export const INJURY_COVERAGE_DRIVER = 'driver' as const
export const INJURY_COVERAGE_PASSENGERS = 'passengers' as const
export const INJURY_COVERAGE = {
  [INJURY_COVERAGE_DRIVER]: 'DRIVER',
  [INJURY_COVERAGE_PASSENGERS]: 'PASSENGERS',
}
export const INJURY_COVERAGE_DEFAULT = INJURY_COVERAGE_DRIVER
